import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";
import axios from "axios";

const Slidere = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const bgColors = [
    "#0073C3",
    "#B61575",
    "#04113E",
    "#0073C3",
    "#B61575",
    "#04113E",
    "#0073C3",
    "#B61575",
    "#0073C3",
    "#B61575",
    "#04113E",
    "#0073C3",
  ];

  const [bgColor, setBgColor] = useState(bgColors[0]);

  const fetchBanners = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/banner_list`,
      );

      if (data?.result) {
        setBanners(data.data);
      } else {
        setError("No banner found");
      }
    } catch (err) {
      setError("Failed to load banners");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const settings = {
    // autoplay: true,
    // infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    fade: true,
    autoplaySpeed: 5000,
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    beforeChange: (oldIndex, newIndex) => {
      setBgColor(bgColors[newIndex]);
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  if (loading)
    return (
      <div
        className="loading-container"
        style={{
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        }}
      >
        <div className="spinner"></div>
      </div>
    );

  return (
    <div
      style={{
        position: "relative",
        zIndex: 1,
        marginBottom: "30px",

        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
        backgroundColor: bgColor,
      }}
    >
      <div className="maintext">
        <Slider {...settings}>
          {banners?.map((item, index) => (
            <div key={index}>
              <div
                className="banner-slide"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "420px",
                  backgroundColor: bgColor,
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <h1
                  className="animate__animated animate__fadeInDown"
                  style={{
                    position: "absolute",
                    top: "25px",
                    left: "10px",
                    right: "10px",
                    fontSize: "2.2rem",
                    fontWeight: "800",
                    color: "#fff",
                    zIndex: 3,
                    margin: 0,
                  }}
                >
                  {item.title}
                </h1>

                {/* Left Side - Content */}
                <div
                  className="banner-content"
                  style={{
                    flex: 1,
                    padding: "50px 40px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    backgroundColor: bgColor,
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  <p
                    className="animate__animated animate__fadeInUp animate__delay-1s"
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      color: "#fff",
                      maxWidth: "500px",
                      marginBottom: "25px",
                      fontWeight: "400",
                      textAlign: "justify",
                    }}
                  >
                    {item.sub_title}
                  </p>
                </div>

                {/* Right Side - Image */}
                <div
                  className="banner-image-container"
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,

                      zIndex: 1,
                    }}
                  />
                  <img
                    className="bannerimg animate__animated animate__fadeIn"
                    src={`${process.env.REACT_APP_API}uploads/${item.banner_image}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      objectPosition: "center",
                      transition: "transform 0.8s ease",
                    }}
                    alt={`Banner ${index + 1}`}
                    onError={(e) => {
                      e.target.src = "/fallback-banner.jpg";
                      e.target.style.backgroundColor = "#f0f0f0";
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "scale(1)";
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Custom Dots Styling */}
      <style>{`
        .slick-dots {
          bottom: 20px !important;
        }
        .slick-dots li button:before {
          font-size: 10px !important;
          color: #fff !important;
          opacity: 0.5 !important;
        }
        .slick-dots li.slick-active button:before {
          opacity: 1 !important;
          color: #fff !important;
        }
        .slick-prev, .slick-next {
          width: 50px !important;
          height: 50px !important;
          z-index: 3 !important;
        }
        .slick-prev:before, .slick-next:before {
          font-size: 24px !important;
          color: #fff !important;
        }
        .slick-prev {
          left: 0px !important;
        }
        .slick-next {
          right: 0px !important;
        }
        .loading-container .spinner {
          width: 50px;
          height: 50px;
          border: 3px solid rgba(26, 35, 126, 0.1);
          border-top-color: #1a237e;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        /* Responsive Styles */
        @media (max-width: 992px) {
          .banner-slide {
            height: 380px !important;
          }
          .banner-content {
            padding: 30px 25px !important;
          }
          h1 {
            font-size: 1.8rem !important;
          }
        }
        
        @@media (max-width: 768px) {
  .banner-slide {
    height: 320px !important;
    flex-direction: row !important; ✅
  }

  .banner-content {
    padding: 20px 15px !important;
  }

  h1 {
    font-size: 1.2rem !important;
  }

  p {
    font-size: 0.85rem !important;
    line-height: 1.4 !important;
  }

  button {
    padding: 8px 18px !important;
    font-size: 0.8rem !important;
  }
}

        
        @media (max-width: 576px) {
          .banner-slide {
            height: 320px !important;
          }
          .banner-content {
            padding: 20px 15px !important;
          }
          h1 {
            font-size: 1rem !important;
          }
          p {
            font-size: 0.7rem !important;
            line-height: 1.5 !important;
          }
          .slick-dots {
            bottom: 10px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Slidere;
